import * as yup from 'yup'

export const getAssetCategoryValidationSchema = (formatMessage: any) =>
  yup.object({
    name: yup.string().required('Category name is required'),
    transportModeId: yup
      .number()
      .defined('Transport mode is required')
      .min(0, 'Transport mode is required'),
  })
